import React, { useEffect, useRef, useState } from 'react';
import Header from '../../components/header';
import Layout from '../../components/layout';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import Icon from '../../components/icons';
import Drawer from '../../components/Drawer';

import { Dropdown, Menu } from '../../components/Dropdown';
import Button from '../../components/elements/button';
import barnhouseImg from '../../images/barn_house_icon.png';
import { useFacilitiesApi } from '../../store/api/hooks/facilitiesApiHook';
import toast from 'react-hot-toast';
//import CreateSubFacilitiesModal from './_components/createSubFacilities.modal';
import { useDialog } from '../../store/api/hooks/dialogHook';
import moment from 'moment';
import { DATE_FORMAT, PAGE_SIZE } from '../../_common/constant';
import Pagination from '../../components/pagination';
import Search from '../../components/search';
import { downloadExcel, downloadPDF, getPermissionInfo, showLocalDate } from '../../_common/functions';
import Loader from '../../components/loader';
import Filters from '../../components/filters';
import { filterConfigType, Option } from '../../_config/types';
import { useAllCitySelector, useAllCountySelector, useDepreciationApportionsSelector, useDepreciationMethodsSelector, useElectricityProvidersSelector, useFacilityManagersSelector, useGasProvidersSelector, useServiceTechsSelector, useStatesSelector, useTeamsSelector, useTelephoneProvidersSelector, useWaterProvidersSelector } from '../../store/selectors/masterSelector';
import { useCommonApi } from '../../store/api/hooks/commonApiHook';
import { StatusStaticCell, StatusStaticWRCell, titleCell } from '../../components/elements/function';
import { useDepreciationApi } from '../../store/api/hooks/depreciationApiHook';
import CreateWorkRequest from './_components/createWorkRequest';
import { useWorkRequestApi } from '../../store/api/hooks/workRequestApiHook';
import { URLS } from '../../_config';
import { useLocation, useNavigate } from 'react-router-dom';
import KanbanView from './_components/kanbanView';
import { useUserSelector } from '../../store/selectors/userSelector';
ModuleRegistry.registerModules([AllCommunityModule]);

const WorkRequest: React.FC = () => {

    const depreciationAPI: any = useDepreciationApi();
    const facilityApi: any = useFacilitiesApi();
    const commonApi: any = useCommonApi();
    const navigate = useNavigate();
    const workRequestAPI: any = useWorkRequestApi();
    const kbviewref = useRef<any>(null);
    const { confirm } = useDialog();

    const [view, setView] = useState<'list' | 'kanban'>('list');

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [priority, setPriority] = useState<any>([]);
    const [rowData, setrowData] = useState<any>(null)
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [subFacilities, setSubFacilities] = useState<any>(null);
    const [subFacilityFor, setSubFacilityFor] = useState<any>(null);
    const [editData, setEditData] = useState<any>(null);
    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [statusList, setStatusList] = useState<any>([]);
    const telephone = useTelephoneProvidersSelector();
    const users = useFacilityManagersSelector();

    const createDrawerRef: any = useRef();
    const createSubFacilityModalRef: any = useRef();
    const subFacilitiesDrawerRef: any = useRef();
    const location = useLocation();
    const loggedinuser: any = useUserSelector();
    const [includeCloseWO, setIncludeCloseWO] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);




    useEffect(() => {
        const payload = {};
        facilityApi.getFacilityList(
            payload,
            (resp: any) => {
                let facilitylist: any = [];
                resp.facilityList.map((facilist: any) => {
                    facilitylist.push({
                        label: facilist.facilityName,
                        value: facilist.facilityID,
                        data: facilist
                    });
                });
                setFacilityoption(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
        workRequestAPI.GetStatusList(
            payload,
            (resp: any) => {
                let deptlist: any = [];

                resp.workRequestStatusList.map((facilist: any) => {
                    deptlist.push({
                        label: facilist.workRequestStatusName,
                        value: facilist.workRequestStatusID,
                    });
                });
                setStatusList(deptlist);



            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
        workRequestAPI.GetPriorityList(
            payload,
            (resp: any) => {
                let facilitylist: any = [];
                resp.workRequestPriorityList.map((facilist: any) => {
                    facilitylist.push({
                        label: facilist.workRequestPriorityName,
                        value: facilist.workRequestPriorityID,
                        data: facilist
                    });
                });
                setPriority(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    }, [])
    useEffect(() => {
        if (users == null) {
            commonApi.GetUserList({
                pageNo: 1,
                pageSize: 1000
            }, (resp: any) => { }, (error: any) => { })
        }
    }, [users])



    const [processingoption, setProcessingoption] = useState<any>(null);

    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('workRequestFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('workRequestFilters', JSON.stringify(filters));
        }
    }, [filters]);
    const filterConfig: filterConfigType[] = [

        { name: 'Facility', type: 'dropdown', key: 'facilityIDs', options: facilityoption ? facilityoption : [] },
        { name: 'Status', type: 'dropdown', key: 'statusIDs', options: statusList ? statusList : [] },
        { name: 'Priority', type: 'dropdown', key: 'priorityIDs', options: priority ? priority : [] },
        { name: 'Requester', type: 'dropdown', key: 'requesterIDs', options: users ? users : [] },
    ]






    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: 'Work Request No', field: 'workRequestCode', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer'> {data.value}  </p>
                )
            }, onCellClicked: (param: any) => {
                navigate(URLS.WORK_REQUEST_DETAILS(param.data.workRequestID));
            }
        },
        {
            headerName: 'Incident Date', field: 'incidentDate', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: (data: any) => {
                return (
                    <p className=''> {showLocalDate(data.value)}  </p>
                )
            }
        },
        { headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', width: 250, cellRenderer: titleCell },
        { headerName: 'Sub-Facility', field: 'wrSubFacilityNames', headerClass: 'bg-[#f0f0f0]', width: 140, cellRenderer: titleCell },
        {
            headerName: 'Description', field: 'description', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 250, cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
                )
            }, onCellClicked: (param: any) => {
                navigate(URLS.WORK_REQUEST_DETAILS(param.data.workRequestID));
            }
        },
        { headerName: 'Priority', field: 'workRequestPriorityName', headerClass: 'bg-[#f0f0f0]', width: 120, cellStyle: { textAlign: 'center' }, cellRenderer: titleCell },
        { headerName: 'Requester', field: 'requsterName', headerClass: 'bg-[#f0f0f0]', width: 120, cellRenderer: (data: any) => <p>{data.value} </p> },
        //{ headerName: 'Status', field: 'workRequestStatusName', headerClass: 'bg-[#f0f0f0]' , width: 160, cellRenderer:(data: any) => <p className={`text-[${data.data.workRequestStatusHexCode}]`}>{data.value} </p> },
        { headerName: 'Status', field: 'workRequestStatusName', headerClass: 'bg-[#f0f0f0]', width: 210, cellRenderer: StatusStaticWRCell },


        {
            headerName: 'Action',
            field: 'action',
            headerClass: 'bg-[#f0f0f0] text-center',
            pinned: 'right',
            width: 90,
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {
                                const action = e.target.value;
                                if (!getPermissionInfo(location.pathname, action, loggedinuser)) {
                                    toast.error(`You don't have ${action} permission`);
                                    e.target.selectedIndex = -1;
                                    return;
                                }
                                handleActionChange(e, params);
                                e.target.selectedIndex = -1;
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            <option disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)} value="edit">Edit</option>
                            <option disabled={!getPermissionInfo(location.pathname, "Delete", loggedinuser)} value="delete">Delete</option>
                        </select>
                    </div>
                )
            }
        },
    ];

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;
        switch (action) {
            case "edit":
                // Implement edit action
                setEditData(rowData);
                createDrawerRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "delete":
                // Implement delete action
                confirm({
                    type: 'delete',
                    title: 'Delete Work Request',
                    message: 'Are you sure you want to delete this Work Request?',
                    onConfirm: () => {
                        const payload = { WorkRequestID: rowData.workRequestID };
                        workRequestAPI.DeleteWorkRequest(payload, (resp: any, msg: any) => {
                            toast.success(msg);
                            GetWorkRequestList();
                        }, (error: any) => {
                            console.log('error =>', error);
                            toast.error(error);
                        });
                    }
                });

                break;
            case "duplicate":
                // Implement view action
                console.log("duplicate action for row: ", rowData);
                break;
            case "qr":
                // Implement qr action
                console.log("qr action for row: ", rowData);
                const payload = { qrFacilityList: [{ facilityID: rowData.facilityID, qty: 1 }], facilityNameInQR: true };
                facilityApi.ExportQrCode(payload, (resp: any) => { downloadPDF(resp, 'FacilityQR') },
                    (error: any) => {
                        toast.error(error);
                    }
                );
                break;
            case "add-sub":
                // Implement add sub action
                console.log("Add sub action for row: ", rowData);
                setSubFacilityFor(rowData.facilityID);
                createSubFacilityModalRef.current.showModal();
                break;
            default:
                console.log("Unknown action: ", action);
        }
        e.target.selectedIndex = -1;
    };

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };


    const onBulkExportPdf = () => {
        const selectedData = getSelectedRows();
        const payload: any = {};
        if (selectedData.length > 0) {
            const workRequestIDs = selectedData.map((asset: any) => asset.workRequestID).join(',');
            payload.WorkRequestIDs = workRequestIDs;
        }
        workRequestAPI.ExportToPDF(
            payload,
            (resp: any) => {
                downloadPDF(resp, 'WorkRequestPdf')
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const onBulkExportCsv = async () => {
        const selectedData = getSelectedRows();
        const payload: any = {};
        if (selectedData.length > 0) {
            const workRequestIDs = selectedData.map((asset: any) => asset.workRequestID).join(',');
            payload.WorkRequestIDs = workRequestIDs;
        }
        workRequestAPI.ExportToXLS(
            payload,
            (resp: any) => { downloadExcel(resp, 'WorkRequestXls') },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const onBulkPrintQR = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            let qrList: any = [];
            selectedData.map((row: any) => qrList.push({ facilityID: row.facilityID, qty: 1 }));
            const payload = { qrFacilityList: qrList, facilityNameInQR: true };
            facilityApi.ExportQrCode(payload, (resp: any) => { downloadPDF(resp, 'FacilityQR') },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };

    const GetWorkRequestList = () => {
        setLoading(true);
        let payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
            statusIDs: '1,2,3,4,5',
        };
        if (includeCloseWO) {
            payload.statusIDs = '1,2,3,4,5,6';
        }
        console.log('helloo', getPermissionInfo(location.pathname, "Can Access Only Own Work Request", loggedinuser), location.pathname, 'helloo');
        

        // Check if user can access only own work requests
        if (loggedinuser && getPermissionInfo(location.pathname, "Can Access Only Own Work Request", loggedinuser)) {
            payload.canAccessOwnOnly = true;
        }

        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        workRequestAPI.GetWorkRequestList(payload, (resp: any) => {
            console.log('resp =>', resp);

            setrowData(resp.workRequestList ? resp.workRequestList : []);
            setTotalRecords(resp.totalRecord);
            setLoading(false);
        }, (error: any) => {
            toast.error(error);
            setLoading(false);
        });
    };

    useEffect(() => {
        //  getProcessingFacilityList()
        //   getfacilitylist();
    }, []);

    // Call GetWorkRequestList only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            GetWorkRequestList();
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {
        if (gridApi?.current) {
            // Auto size all columns based on their content
            gridApi?.current.sizeColumnsToFit();
        }
    }, [gridApi]);

    useEffect(() => {
        if (filtersInitialized) {
            GetWorkRequestList();
        }
        
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
        });
    }, [currentPage, searchParam, filters, includeCloseWO]);

    const opensubfacility = (facilityID: any) => {
        setSubFacilityFor(facilityID);
        createSubFacilityModalRef.current.showModal();
    }

    const createFacilityRef: any = useRef();

    return (
        <Layout>
            <Header title='Work Request List'>
                <Header.Right>
                    <div className='border border-primary rounded-md overflow-hidden'>
                        <Button theme={view == 'list' ? 'primary' : 'light'} className='!rounded-none !border-0' onClick={() => {
                            setView('list')
                        }}>List View</Button>
                        <Button theme={view == 'kanban' ? 'primary' : 'light'} className='!rounded-none !border-0' onClick={() => { setView('kanban') }}>Kanban View</Button>
                    </div>
                    <Drawer _ref={createDrawerRef} isAfterOpenRender={true} onClose={() => {
                        console.log('close drawer', createFacilityRef?.current?.reset);
                        createFacilityRef?.current?.reset()
                        if (view == 'kanban') {
                            kbviewref.current?.reload();
                        }
                        setEditData(null)
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button disabled={!getPermissionInfo(location.pathname, "Add", loggedinuser)}>Create New Request</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Work Request' : 'Create New Work Request'} className='!w-[39.563rem]'>
                            {!getPermissionInfo(location.pathname, editData ? "Edit" : "Add", loggedinuser) ? (
                                <div className="p-4 text-red-500">
                                    You don’t have permission to access this form.
                                </div>
                            ) : (
                                <CreateWorkRequest _ref={createFacilityRef} editData={editData} onCreate={() => {
                                    setEditData(null);
                                    GetWorkRequestList();
                                    if (view == 'kanban') {
                                        window.dispatchEvent(new CustomEvent(`page_tab_WR_created`, { detail: { message: { ACTION: `RELOAD`, data: null } } }));
                                    }
                                    createDrawerRef?.current?.close();
                                }} onCancel={() => {

                                    setEditData(null);
                                    GetWorkRequestList()
                                    createDrawerRef?.current?.close()
                                }} />)}
                        </Drawer.Content>
                    </Drawer>
                    {view !== `kanban` && (
                        <Dropdown>
                            <Dropdown.Button>
                                <Button theme='secondary'>Bulk Actions</Button>
                            </Dropdown.Button>
                            <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                                {/* <Menu onClick={onBulkPrintQR}>Move Assets</Menu> */}
                                <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportCsv}>Export excel / csv </Menu>
                                <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportPdf}>Export pdf</Menu>
                            </Dropdown.Content>
                        </Dropdown>
                    )}
                </Header.Right>
            </Header>
            {view == 'list' &&
                <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                    <Pagination
                        perPage={PAGE_SIZE}
                        totalRecords={totalRecords}
                        onPageChange={setCurrentPage}
                        currentPage={currentPage}
                    />
                    <Search onSearch={setSearchParam} placeholder='Search by WR no or facility' />
                </div>
            }
            <div className='w-full'>
                {view != 'kanban' && (
                    <div className="bg-[#FAFAFA] flex justify-between px-5 py-2 items-center">
                        {/* Left side buttons */}
                        <div className="flex gap-4 items-center">
                            <Button
                                theme="light"
                                onClick={() => filtersRef.current.showModal()}
                            >
                                Filter{" "}
                                <Icon
                                    name="filter"
                                    size={1.4}
                                    className={filtersApplied.generalFilter ? "text-blue-700" : ""}
                                />
                            </Button>
                            <p
                                className="text-primary font-semibold text-sm cursor-pointer"
                                onClick={() => {
                                    setFilters({});
                                    localStorage.removeItem('workRequestFilters');
                                }}
                            >
                                Clear Filters
                            </p>
                        </div>

                        {/* Right side button */}
                        <div className="border border-primary rounded-md overflow-hidden flex">
                            <Button
                                theme={includeCloseWO ? "blue" : "light"}
                                className="!rounded-none !border-0 px-3"
                                onClick={() => setIncludeCloseWO(prev => !prev)}
                            >
                                Include Closed Request
                            </Button>
                        </div>
                    </div>
                )}

                {view == 'list' &&
                    <div className="ag-theme-alpine px-4 w-full h-1/2">
                        {/* <Drawer _ref={subFacilitiesDrawerRef} onClose={() => setSubFacilities(null)}>
                        <Drawer.Button>
                            {null}
                        </Drawer.Button>
                        <Drawer.Content title={subFacilities?.facilityName} className='!w-[39.563rem]'>
                            <SubFacilities data={subFacilities} onCancel={()=>{subFacilitiesDrawerRef?.current?.close(); setSubFacilities(null)}}  onCreatesub={()=>{opensubfacility(subFacilities?.facilityID) }} />
                        </Drawer.Content>
                    </Drawer> */}
                        {loading ? (
                            <div className="flex items-center justify-center h-64">
                                <Loader />
                            </div>
                        ) : (
                            <AgGridReact
                                columnDefs={columnDefs as any} // Pass columnDefs
                                rowData={rowData || []} // Pass rowData
                                rowSelection="multiple"
                                onGridReady={onGridReady}
                                pagination={false}
                                domLayout="autoHeight"
                                onRowClicked={onRowClicked}
                                loadingOverlayComponent={Loader}
                                noRowsOverlayComponent={() => (
                                    <div className="flex items-center justify-center h-full">
                                        <div className="text-center text-gray-500">
                                            <div className="text-lg font-medium">No Data Found</div>
                                        </div>
                                    </div>
                                )}
                            />
                        )}
                    </div>
                }


                {view == 'kanban' &&
                    <div className="">
                        <KanbanView _ref={kbviewref} canEdit={getPermissionInfo(location.pathname, "Edit", loggedinuser)} />
                    </div>
                }



            </div>
            {/* <CreateSubFacilitiesModal _ref={createSubFacilityModalRef} facilityId={subFacilityFor} /> */}
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={(data: any) => {
                setFilters(data);
                if (view == 'kanban') {
                    window.dispatchEvent(new CustomEvent(`page_tab_WR_created`, { detail: { message: { ACTION: `FILTER`, data: data } } }));
                }
            }} />
        </Layout>
    );
};

export default WorkRequest;